export const SYSTEM_TYPE = {
  BRANCH_OFFICE: 'Branch-Office',
  HEAD_OFFICE: 'Head-Office',
  MULTI_OFFICE: 'Multi-Office',
  MULTI_SUB_OFFICE: 'Multi-Sub-Office',
  LITE_OFFICE: 'Lite-Office',
  SINGLE_OFFICE: 'Single-Office',
}
